"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class EvaluationRequestOffer {
  static thaw(evaluationRequestOfferObj) {
    if (evaluationRequestOfferObj == null) return null;
    const evaluationRequestOffer = new EvaluationRequestOffer();
    if (evaluationRequestOfferObj.id != null) evaluationRequestOffer.setId(evaluationRequestOfferObj.id);
    if (evaluationRequestOfferObj.status != null) evaluationRequestOffer.setStatus(evaluationRequestOfferObj.status);
    if (evaluationRequestOfferObj.offeredTimestamp != null) evaluationRequestOffer.setOfferedTimestamp(_luxon.DateTime.fromISO(evaluationRequestOfferObj.offeredTimestamp));
    if (evaluationRequestOfferObj.acceptedTimestamp != null) evaluationRequestOffer.setAcceptedTimestamp(_luxon.DateTime.fromISO(evaluationRequestOfferObj.acceptedTimestamp));
    if (evaluationRequestOfferObj.rejectedTimestamp != null) evaluationRequestOffer.setRejectedTimestamp(_luxon.DateTime.fromISO(evaluationRequestOfferObj.rejectedTimestamp));
    if (evaluationRequestOfferObj.autoRejectedTimestamp != null) evaluationRequestOffer.setAutoRejectedTimestamp(_luxon.DateTime.fromISO(evaluationRequestOfferObj.autoRejectedTimestamp));
    if (evaluationRequestOfferObj.canceledTimestamp != null) evaluationRequestOffer.setCanceledTimestamp(_luxon.DateTime.fromISO(evaluationRequestOfferObj.canceledTimestamp));
    if (evaluationRequestOfferObj.withdrawnTimestamp != null) evaluationRequestOffer.setWithdrawnTimestamp(_luxon.DateTime.fromISO(evaluationRequestOfferObj.withdrawnTimestamp));
    if (evaluationRequestOfferObj.evaluationRequestId != null) evaluationRequestOffer.setEvaluationRequestId(evaluationRequestOfferObj.evaluationRequestId);
    if (evaluationRequestOfferObj.evaluatorId != null) evaluationRequestOffer.setEvaluatorId(evaluationRequestOfferObj.evaluatorId);
    if (evaluationRequestOfferObj.evaluatorGroupId != null) evaluationRequestOffer.setEvaluatorGroupId(evaluationRequestOfferObj.evaluatorGroupId);
    if (evaluationRequestOfferObj.evaluationRequest != null) evaluationRequestOffer.setEvaluationRequest(_.EvaluationRequest.thaw(evaluationRequestOfferObj.evaluationRequest));
    if (evaluationRequestOfferObj.evaluatorGroup != null) evaluationRequestOffer.setEvaluatorGroup(_.Group.thaw(evaluationRequestOfferObj.evaluatorGroup));
    return evaluationRequestOffer;
  }

  static thawList(evaluationRequestOfferObjList) {
    if (evaluationRequestOfferObjList == null) return [];
    var evaluationRequestOffers = [];

    for (var i = 0; i < evaluationRequestOfferObjList.length; i++) {
      evaluationRequestOffers.push(EvaluationRequestOffer.thaw(evaluationRequestOfferObjList[i]));
    }

    return evaluationRequestOffers;
  }

  static freeze(evaluationRequestOffer) {
    if (evaluationRequestOffer == null) return null;
    var evaluationRequestOfferObj = {};
    if (evaluationRequestOffer.getId() != null) evaluationRequestOfferObj.id = evaluationRequestOffer.getId();
    if (evaluationRequestOffer.getStatus() != null) evaluationRequestOfferObj.status = evaluationRequestOffer.getStatus();
    if (evaluationRequestOffer.getOfferedTimestamp() != null) evaluationRequestOfferObj.offeredTimestamp = evaluationRequestOffer.getOfferedTimestamp();
    if (evaluationRequestOffer.getAcceptedTimestamp() != null) evaluationRequestOfferObj.acceptedTimestamp = evaluationRequestOffer.getAcceptedTimestamp();
    if (evaluationRequestOffer.getRejectedTimestamp() != null) evaluationRequestOfferObj.rejectedTimestamp = evaluationRequestOffer.getRejectedTimestamp();
    if (evaluationRequestOffer.getAutoRejectedTimestamp() != null) evaluationRequestOfferObj.autoRejectedTimestamp = evaluationRequestOffer.getAutoRejectedTimestamp();
    if (evaluationRequestOffer.getCanceledTimestamp() != null) evaluationRequestOfferObj.canceledTimestamp = evaluationRequestOffer.getCanceledTimestamp();
    if (evaluationRequestOffer.getWithdrawnTimestamp() != null) evaluationRequestOfferObj.withdrawnTimestamp = evaluationRequestOffer.getWithdrawnTimestamp();
    if (evaluationRequestOffer.getEvaluationRequestId() != null) evaluationRequestOfferObj.evaluationRequestId = evaluationRequestOffer.getEvaluationRequestId();
    if (evaluationRequestOffer.getEvaluatorId() != null) evaluationRequestOfferObj.evaluatorId = evaluationRequestOffer.getEvaluatorId();
    if (evaluationRequestOffer.getEvaluatorGroupId() != null) evaluationRequestOfferObj.evaluatorGroupId = evaluationRequestOffer.getEvaluatorGroupId();
    if (evaluationRequestOffer.getEvaluationRequest() != null) evaluationRequestOfferObj.evaluationRequest = _.EvaluationRequest.freeze(evaluationRequestOffer.getEvaluationRequest());
    if (evaluationRequestOffer.getEvaluatorGroup() != null) evaluationRequestOfferObj.evaluatorGroup = _.Group.freeze(evaluationRequestOffer.getEvaluatorGroup());
    return evaluationRequestOfferObj;
  }

  static freezeList(evaluationRequestOffers) {
    if (evaluationRequestOffers == null) return [];
    var evaluationRequestOfferObjList = [];

    for (var i = 0; i < evaluationRequestOffers.length; i++) {
      evaluationRequestOfferObjList.push(EvaluationRequestOffer.freeze(evaluationRequestOffers[i]));
    }

    return evaluationRequestOfferObjList;
  }

  constructor() {
    this.setId(null);
    this.setStatus(null);
    this.setOfferedTimestamp(null);
    this.setAcceptedTimestamp(null);
    this.setRejectedTimestamp(null);
    this.setAutoRejectedTimestamp(null);
    this.setCanceledTimestamp(null);
    this.setWithdrawnTimestamp(null);
    this.setEvaluationRequestId(null);
    this.setEvaluatorId(null);
    this.setEvaluatorGroupId(null);
    this.setEvaluationRequest(null);
    this.setEvaluatorGroup(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setStatus(status) {
    this.status = status;
  }

  setOfferedTimestamp(offeredTimestamp) {
    this.offeredTimestamp = offeredTimestamp;
  }

  setAcceptedTimestamp(acceptedTimestamp) {
    this.acceptedTimestamp = acceptedTimestamp;
  }

  setRejectedTimestamp(rejectedTimestamp) {
    this.rejectedTimestamp = rejectedTimestamp;
  }

  setAutoRejectedTimestamp(autoRejectedTimestamp) {
    this.autoRejectedTimestamp = autoRejectedTimestamp;
  }

  setCanceledTimestamp(canceledTimestamp) {
    this.canceledTimestamp = canceledTimestamp;
  }

  setWithdrawnTimestamp(withdrawnTimestamp) {
    this.withdrawnTimestamp = withdrawnTimestamp;
  }

  setEvaluationRequestId(evaluationRequestId) {
    this.evaluationRequestId = evaluationRequestId;
  }

  setEvaluatorId(evaluatorId) {
    this.evaluatorId = evaluatorId;
  }

  setEvaluatorGroupId(evaluatorGroupId) {
    this.evaluatorGroupId = evaluatorGroupId;
  }

  setEvaluationRequest(evaluationRequest) {
    this.evaluationRequest = evaluationRequest;
  }

  setEvaluatorGroup(evaluatorGroup) {
    this.evaluatorGroup = evaluatorGroup;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getStatus() {
    return this.status;
  }

  getOfferedTimestamp() {
    return this.offeredTimestamp;
  }

  getAcceptedTimestamp() {
    return this.acceptedTimestamp;
  }

  getRejectedTimestamp() {
    return this.rejectedTimestamp;
  }

  getAutoRejectedTimestamp() {
    return this.autoRejectedTimestamp;
  }

  getCanceledTimestamp() {
    return this.canceledTimestamp;
  }

  getWithdrawnTimestamp() {
    return this.withdrawnTimestamp;
  }

  getEvaluationRequestId() {
    return this.evaluationRequestId;
  }

  getEvaluatorId() {
    return this.evaluatorId;
  }

  getEvaluatorGroupId() {
    return this.evaluatorGroupId;
  }

  getEvaluationRequest() {
    return this.evaluationRequest;
  }

  getEvaluatorGroup() {
    return this.evaluatorGroup;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationRequestOffer;